<template>
  <v-container fluid>
    <v-card class="px-2 pb-2 mb-3">
      <v-card-title primary-title>
        <span class="title">Historical Sales</span>
      </v-card-title>
      <v-layout wrap justify-space-around fill-height>
        <v-flex xs5 sm2 md2>
          <v-text-field
            v-model="stringDate"
            label="Sale Date Id"
            append-icon="search"
            @click:append="onSearch"
            v-on:keyup.enter="onSearch"
            :disabled="dataReady"
          ></v-text-field>
        </v-flex>
        <v-flex xs5 sm2 md2>
          <v-text-field v-model="status" label="Status" disabled></v-text-field>
        </v-flex>
        <v-flex xs5 sm2 md2>
          <v-text-field v-model="isActive" label="Is Active" disabled></v-text-field>
        </v-flex>
        <v-flex xs5 sm2 md2>
          <v-combobox
            v-model="selectToken"
            :items="tokens"
            label="Select a Token"
            :disabled="dataReady"
          ></v-combobox>
        </v-flex>
      </v-layout>
      <div v-if="loading">
        <v-progress-linear
          indeterminate
          height="2"
          class="ma-0"
          style="position: absolute; bottom: 0px; left: 0; right: 0;"
        ></v-progress-linear>
      </div>
    </v-card>

    <div v-if="selectToken" style="margin-top: 15px;">
      <v-card>
        <v-card-text
          v-if="dataLoading"
          class="text-xs-center pa-3"
          style="transform: translateY(0px);"
        >
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <div v-else-if="!dataLoading">
          <div v-if="!filteredList">
            <v-layout row wrap>
              <v-flex d-flex xs12 class="text-xs-center">
                <span class="grey--text">
                  <i>
                    <h1>Empty</h1>
                  </i>
                </span>
              </v-flex>
            </v-layout>
          </div>

          <v-layout v-if="filteredList" wrap fill-height>
            <v-card-title>
              <h4>Exchange : {{ selectToken }}</h4>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-flex xs8 sm5 md4 pa-2 shrink style="margin-right: 30px">
              <div v-if="selectToken === 'XRP'">
                <v-autocomplete
                  v-model="accountId"
                  :items="xrpAccounts"
                  item-text="key"
                  item-value="value"
                  :search-input.sync="accountSearch"
                  :filter="filterId"
                  :disabled="dataReady"
                  clearable
                />
              </div>
              <div v-else-if="selectToken === 'MESG'">
                <v-autocomplete
                  v-model="accountId"
                  :items="mesgAccounts"
                  item-text="key"
                  item-value="value"
                  :search-input.sync="accountSearch"
                  :filter="filterId"
                  :disabled="dataReady"
                  clearable
                />
              </div>
            </v-flex>
            <v-expansion-panel v-if="filteredList">
              <v-expansion-panel-content
                v-for="(exchange,i) in filteredList.exchanges"
                :key="i"
                lazy
              >
                <div slot="header">
                  <v-card-title primary-title>
                    <h3>
                      Account ID :
                      <u>{{exchange.account_id}}</u>
                    </h3>
                  </v-card-title>
                </div>
                <v-card>
                  <v-card-text>
                    <v-form ref="form" lazy-validation :data="{ index: i }">
                      <template v-for="section in sections">
                        <div :key="section.name">
                          <div>
                            <h3>
                              <u>{{section.name}}</u>
                            </h3>
                          </div>
                          <v-layout wrap fill-height>
                            <template v-for="(item, index) in section.items">
                              <v-flex xs12 pa-1 shrink md4 :key="index">
                                <v-autocomplete
                                  v-if="item.autocomplete"
                                  v-model="exchange[item.key]"
                                  :items="item.autocomplete"
                                  :item-text="item.autocompleteKey || 'key'"
                                  :item-value="item.autocompleteValue || 'value'"
                                  :filter="item.filterObjId || filterId"
                                  :label="item.label"
                                  color="green"
                                  :chips="item.chips"
                                  :deletable-chips="item.deletableChips"
                                  :multiple="item.multiple"
                                  :rules="item.inputRule"
                                  :return-object="item.returnObject"
                                ></v-autocomplete>
                                <v-text-field
                                  v-else-if="item.textField"
                                  :key="i"
                                  v-model="exchange[item.key]"
                                  :label="item.label"
                                  :type="item.type"
                                  color="green"
                                  :rules="item.inputRule"
                                  :required="item.required"
                                ></v-text-field>
                                <div v-else>
                                  <template>
                                    <v-layout wrap fill-height>
                                      <v-btn
                                        fab
                                        dark
                                        small
                                        color="primary"
                                        @click="addDailyWithdrawLimit(exchange[item.key])"
                                      >
                                        <v-icon dark>add</v-icon>
                                      </v-btn>
                                    </v-layout>
                                    <v-card
                                      v-for="(value,dailyIndex) in exchange[item.key]"
                                      :key="dailyIndex"
                                      class="elevation-4 ma-2 mb-3"
                                    >
                                      <v-layout wrap fill-height>
                                        <v-flex xs10 style="padding: 10px 0px 5px 20px">
                                          <v-text-field
                                            label="Currency"
                                            v-model="value.currency"
                                            :rules="inputRule"
                                          ></v-text-field>
                                          <v-text-field
                                            label="Amount"
                                            v-model="value.amount"
                                            type="number"
                                            :rules="numberRule"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex style="text-align: center">
                                          <v-btn
                                            flat
                                            icon
                                            class="btn-toolbar"
                                            @click.native.stop="removeDailyWithdrawLimit(exchange[item.key],index)"
                                          >
                                            <v-icon>delete</v-icon>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-card>
                                  </template>
                                </div>
                              </v-flex>
                            </template>
                          </v-layout>
                        </div>
                      </template>
                      <v-layout wrap justify-end fill-height>
                        <v-btn
                          :loading="validate"
                          :disabled="validate"
                          @click.native.prevent="()=> (dialog= true,dialogData = {filteredList,exchange,i},validate=true)"
                          color="success"
                        >Validate</v-btn>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <div>
              <v-dialog v-model="dialog" persistent max-width="290">
                <v-card>
                  <v-layout row wrap justify-center>
                    <v-icon x-large color="orange">error_outline</v-icon>
                    <v-card-title class="headline">Are you sure?</v-card-title>
                  </v-layout>
                  <v-card-text>You won't be able to revert this!</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                      color="orange darken-1"
                      flat="flat"
                      @click.prevent="() => onSubmit(dialogData)"
                    >Yes,edit it !!</v-btn>
                    <v-btn
                      color="red darken-1"
                      flat="flat"
                      @click="dialog = false,validate=false"
                    >Cancel</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-layout>
        </div>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { isEmpty } from 'lodash'
import Vue from 'vue'
import MongoService from '../../services/mongo.service'
import MongoConnector from '../../services/mongo-connector.service'
import { getDefaultConnectorSchema } from '../../configs/schemas'
import Alert from '../../libs/alert'
import MessageDialog from '../../libs/message-dialog/'
export default {
  data() {
    const historicalService = new MongoConnector(
      getDefaultConnectorSchema(null, 'historical-sales')
    )
    const accountsService = new MongoConnector(
      getDefaultConnectorSchema(null, 'accounts')
    )
    const botConfigsService = new MongoConnector(
      getDefaultConnectorSchema(null, 'bot-configs')
    )
    return {
      stringDate: new Date().toISOString().split('T')[0],
      historicalService,
      accountsService,
      botConfigsService,
      selectToken: 'XRP',
      tokens: [],
      historicalSales: [],
      accounts: [],
      currency: [],
      xrp: [],
      mesg: [],
      accountId: null,
      status: '-',
      isActive: '-',
      loading: false,
      dataLoading: false,
      accountSearch: undefined,
      accountsExchanges: [],
      xrpAccounts: [],
      mesgAccounts: [],
      sections: [],
      relateAccount: [],
      inputRule: [v => !!v || 'This field is required'],
      numberRule: [
        v => /^(\d+\.\d+)$|^(-?\d+)$/.test(v) || 'This field is required number'
      ],
      formArray: [],
      formIndxArray: 0,
      dialogData: null,
      dialog: false,
      dataReady: false,
      validate: false
    }
  },
  async mounted() {
    try {
      this.loading = true
      this.dataReady = true
      const [historicalSales, accounts, currency] = await Promise.all([
        this.historicalService.find({
          filter: { sale_date_id: this.stringDate }
        }),
        this.accountsService.find({
          sort: { account_id: 1 },
          limit: 1000
        }),
        this.botConfigsService.find({
          sort: { account_id: -1 },
          limit: 500
        })
      ])
      this.historicalSales = historicalSales

      this.accounts = accounts.map(({ account_id, exchange }) => {
        return { key: account_id, value: account_id, exchange }
      })

      this.relateAccount = accounts.map(obj => {
        return obj
      })

      this.accountsExchanges = [
        ...new Set(this.accounts.map(data => data.exchange))
      ].map(data => ({ key: data, value: data }))

      this.currency = [
        ...new Set(
          currency.map(data => [data.base_currency, data.quote_currency]).flat()
        )
      ]
        .filter(currencyExchange => currencyExchange != null)
        .map(data => {
          return { key: data, value: data }
        })

      this.xrp = this.historicalSales.find(data => {
        if (data.token === 'XRP') {
          return data.exchanges
        }
      })
      this.mesg = this.historicalSales.find(data => {
        if (data.token === 'MESG') {
          return data.exchanges
        }
      })

      this.tokens = this.historicalSales.map(data => data.token)

      if (!isEmpty(this.xrp)) {
        this.xrpAccounts = this.xrp.exchanges.map(exchange => {
          return { key: exchange.account_id, value: exchange.account_id }
        })
      }
      if (!isEmpty(this.mesg)) {
        this.mesgAccounts = this.mesg.exchanges.map(exchange => {
          return { key: exchange.account_id, value: exchange.account_id }
        })
      }

      this.sections = [
        {
          name: 'Sales',
          items: [
            {
              key: 'account_id',
              label: 'Account ID',
              autocomplete: this.accounts,
              inputRule: this.inputRule,
              itemText: 'key',
              itemValue: 'value'
            },
            {
              key: 'exchange',
              label: 'Exchange',
              autocomplete: this.accountsExchanges,
              inputRule: this.inputRule
            },
            {
              key: 'sub_account_id',
              label: 'Sub Account ID',
              type: 'text',
              textField: true
            },
            {
              key: 'amount_to_sell',
              label: 'Target',
              type: 'number',
              textField: true
            },
            {
              key: 'volume_from',
              label: 'Volume From',
              type: 'number',
              textField: true,
              inputRule: this.inputRule,
              required: true
            },
            {
              key: 'volume_to',
              label: 'Volume To',
              type: 'number',
              textField: true,
              inputRule: this.inputRule,
              required: true
            }
          ]
        },
        {
          name: 'Pair',
          items: [
            {
              key: 'from_currency',
              label: 'From Currency',
              autocomplete: this.currency,
              inputRule: this.inputRule
            },
            {
              key: 'intermediate_currency',
              label: 'Intermediate Currency',
              autocomplete: this.currency
            },
            {
              key: 'to_currency',
              label: 'To Currency',
              autocomplete: this.currency,
              inputRule: this.inputRule
            }
          ]
        },
        {
          name: 'Configs',
          items: [
            {
              key: 'empty_trigger',
              label: 'Empty Trigger',
              type: 'number',
              textField: true,
              inputRule: this.inputRule,
              required: true
            },
            {
              key: 'minimum_withdraw',
              label: 'Minimum Withdraw',
              type: 'number',
              textField: true,
              inputRule: this.inputRule,
              required: true
            },
            {
              key: 'maximum_withdraw',
              label: 'Maximum Withdraw',
              type: 'number',
              textField: true,
              inputRule: this.inputRule,
              required: true
            },
            {
              key: 'speed_up_factor',
              label: 'Speed Up Factor',
              type: 'number',
              textField: true,
              inputRule: this.inputRule,
              required: true
            },
            {
              key: 'transaction_frequency_seconds',
              label: 'Transaction Frequency Seconds',
              type: 'number',
              textField: true,
              inputRule: this.numberRule,
              required: true
            }
          ]
        },
        {
          name: 'Daily Withdraw Limit',
          items: [
            {
              key: 'daily_withdraw_limit'
            }
          ]
        },
        {
          name: 'Related Account Ids',
          items: [
            {
              key: 'related_account_ids',
              label: 'Account ID',
              autocomplete: this.relateAccount,
              autocompleteKey: 'account_id',
              autocompleteValue: 'account_id',
              chips: true,
              deletableChips: true,
              multiple: true,
              returnObject: true,
              filterObjId: this.filterObjId
            }
          ]
        }
      ]

      this.loading = false
      this.dataReady = false
    } catch (e) {
      MessageDialog.showErrorMessage({ text: e.toString() })
    }
  },
  computed: {
    filteredList() {
      this.dataLoading = true
      if (this.selectToken === 'XRP') {
        if (!this.xrp) {
          this.dataLoading = false
          return undefined
        }

        if (!this.accountId) {
          this.dataLoading = false
          return this.xrp
        }

        this.dataLoading = false
        const ObjectToArray = [this.xrp]

        const searchValue = ObjectToArray.map(data =>
          data.exchanges.filter(ex =>
            ex.account_id.includes(this.accountSearch)
          )
        )
        return Object.assign({}, { exchanges: [...searchValue.flat()] })
      }
      if (this.selectToken === 'MESG') {
        if (!this.mesg) {
          this.dataLoading = false
          return undefined
        }
        if (!this.accountId) {
          this.dataLoading = false
          return this.mesg
        }
        this.dataLoading = false

        const ObjectToArray = [this.mesg]

        const searchValue = ObjectToArray.map(data =>
          data.exchanges.filter(ex =>
            ex.account_id.includes(this.accountSearch)
          )
        )
        return Object.assign({}, { exchanges: [...searchValue.flat()] })
      }
    }
  },
  methods: {
    async onSubmit(data) {
      const { filteredList, i, exchange } = data
      const form = this.$refs.form.find(f => f.$attrs.data.index === i)
      const validated = form.validate()
      if (validated) {
        try {
          this.dialog = false
          await this.historicalService.updateDocuments(
            filteredList.exchanges.length > 1
              ? filteredList
              : this.historicalSales
          )
          await Alert.success({ message: `${exchange.account_id} updated` })
          this.validate = false
        } catch (e) {
          MessageDialog.showErrorMessage({ text: e.toString() })
        }
      } else {
        this.dialog = false
        await Alert.error({ message: `${exchange.account_id} incorrect` })
        this.validate = false
      }
    },
    filterId(items, queryText, itemText) {
      const textValue = items.value.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textValue.indexOf(searchText) > -1
    },
    filterObjId(items, queryText, itemText) {
      const textValue = items.account_id.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textValue.indexOf(searchText) > -1
    },
    async onSearch() {
      try {
        this.dataLoading = true
        this.dataReady = true
        this.accountId = null

        if (isEmpty(this.stringDate)) {
          this.stringDate = new Date().toISOString().split('T')[0]
        }

        const [historicalSales] = await Promise.all([
          this.historicalService.find({
            filter: { sale_date_id: this.stringDate }
          })
        ])

        this.historicalSales = historicalSales
        this.xrp = this.historicalSales.find(data => {
          if (data.token === 'XRP') {
            return data.exchanges
          }
        })
        this.mesg = this.historicalSales.find(data => {
          if (data.token === 'MESG') {
            return data.exchanges
          }
        })
        if (!isEmpty(this.xrp)) {
          this.xrpAccounts = this.xrp.exchanges.map(exchange => {
            return { key: exchange.account_id, value: exchange.account_id }
          })
        }
        if (!isEmpty(this.mesg)) {
          this.mesgAccounts = this.mesg.exchanges.map(exchange => {
            return { key: exchange.account_id, value: exchange.account_id }
          })
        }
        this.tokens = this.historicalSales.map(data => data.token)

        this.dataLoading = false
        this.dataReady = false
      } catch (e) {
        MessageDialog.showErrorMessage({ text: e.toString() })
      }
    },
    addDailyWithdrawLimit(item) {
      const dailyWithdrawLimit = { currency: '', amount: 0 }
      item.push(dailyWithdrawLimit)
    },
    removeDailyWithdrawLimit(item, index) {
      item.splice(index, 1)
    }
  },
  watch: {
    selectToken: {
      immediate: true,
      handler(val) {
        if (val === 'XRP') {
          this.status = this.xrp.status
          this.isActive = this.xrp.is_active
        }
        if (val === 'MESG') {
          if (!isEmpty(this.mesg)) {
            this.status = this.mesg.status
            this.isActive = this.mesg.is_active
          }
        }
      }
    }
  }
}
</script>
